// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-date-editor[data-v-72bf147d]{width:100%;height:40px;padding:10px 0 10px 10px}.el-date-editor[data-v-72bf147d]  .el-range-separator{width:8%}", ""]);
// Exports
module.exports = exports;
